import { GET_USER_LOG_REQUEST, GET_USER_LOG_SUCCESS, GET_USER_LOG_ERROR } from "./types";
import { BASEURL } from "../../constant/config.js";
const axios = require("axios");

export const getUserLog = (token, menu_id) => (dispatch) => {
    dispatch({ type: GET_USER_LOG_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/getUserLog`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id }
    })
        .then((response) => {
            return dispatch({ type: GET_USER_LOG_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_USER_LOG_ERROR,
                payload: error.response,
            });
        });
};
